// Not a <Surface>: that is a 14px card and paints a box-shadow this page card must not have.
export const CARD_RADIUS = 'var(--malachite-radius-xxxl, 16px)';
export const CARD_CLASSES =
    'w-full overflow-hidden bg-[var(--malachite-card-background)] border border-solid border-[var(--malachite-card-border)]';
export const DIVIDER_CLASSES = 'border-b border-solid border-[var(--malachite-card-border)]';

// 56, not Figma's 60: the app sidebar's divider sits at 9 + 56 and this header's must land
// on the same line (8px page inset + 1px card border + 56). Move both together or neither.
export const HEADER_HEIGHT = 56;
export const CARD_MIN_HEIGHT = 'calc(100vh - 16px)';
// 136 is not derivable from the constants above: the extra 64px is app chrome above the card.
export const CONTENT_MIN_HEIGHT = 'calc(100vh - 136px)';

// Set by RegularLayout to its own horizontal content padding, so a `bleed` child can pull
// itself out to the page card's edges without knowing which layout variant wraps it.
export const CONTENT_INSET_VAR = '--malachite-page-content-inset';
export const CONTENT_INSET = `var(${CONTENT_INSET_VAR}, 0px)`;
